import React from 'react'

export const NotFound: React.FC = () => {
  return <div className={'NotFound'}>
    <h1>
      404 - Página no encontrada
    </h1>
  </div>
}